
import React from "react";
import { DragDropContext, Droppable } from "@hello-pangea/dnd";
import { Loader2 } from "lucide-react";
import { ParcelType } from "@/hooks/useParcelTypes";
import ParcelTypeItem from "./ParcelTypeItem";

interface ParcelTypesListProps {
  parcelTypes: ParcelType[];
  onDragEnd: (result: any) => void;
  onEdit: (parcelType: ParcelType) => void;
  onDelete: (id: string) => void;
  onToggleEnabled: (parcelType: ParcelType) => void;
  reordering: boolean;
}

const ParcelTypesList = ({ 
  parcelTypes, 
  onDragEnd, 
  onEdit, 
  onDelete, 
  onToggleEnabled, 
  reordering 
}: ParcelTypesListProps) => {
  return (
    <div>
      {reordering && (
        <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-center gap-2">
          <Loader2 className="h-4 w-4 animate-spin text-blue-600" />
          <span className="text-sm text-blue-800">Updating parcel type order...</span>
        </div>
      )}
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="parcel-types">
          {(provided) => (
            <div {...provided.droppableProps} ref={provided.innerRef} className="space-y-2">
              {parcelTypes.map((parcelType, index) => (
                <ParcelTypeItem
                  key={parcelType.id}
                  parcelType={parcelType}
                  index={index}
                  onEdit={onEdit}
                  onDelete={onDelete}
                  onToggleEnabled={onToggleEnabled}
                  reordering={reordering}
                />
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};

export default ParcelTypesList;
